export default __webpack_public_path__ + "static/property3-95959fd22236e7189339df4c5276763c.png";